<template>
  <div :class="['vcircle', { checked: value, disabled }]" @click="$emit('input', !value)">
    <div v-if="value" class="point"></div>
  </div>
</template>

<script>
export default {
  name: 'Vcircle',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.vcircle {
  display: flex;
  border: 2px solid #010101;
  background: $white;
  opacity: 0.5;
  min-width: 18px;
  max-width: 18px;
  min-height: 18px;
  max-height: 18px;
  border-radius: 50%;
  cursor: pointer;
  box-sizing: border-box;
  padding: 2px;

  &.checked {
    border-color: $green;
    opacity: 1;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .point {
    background-color: $green;
    min-width: 100%;
    min-height: 100%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    box-sizing: border-box;
  }
}
</style>
